<div class="mt-4 d-flex flex-column align-items-center">
  @let title = config().title;
  @let bisCampaignActive =
    dataService.environment().hasCampaignBis &&
    dataService.hasCurrentBisCampaign();
  @if (title && (!bisCampaignActive || title.displayWhenCampaignBis)) {
    @if (title.type === TitleType.IMAGE) {
      <img
        class="title-image {{ environment.retailerName }}"
        [src]="title.picture.imageUrl"
        [alt]="title.picture.alternativeText"
      />
    } @else if (title.type === TitleType.TEXT) {
      <div
        class="title-container"
        [style]="title.styles"
        [innerHTML]="title.label | safe"
      ></div>
    }
  }

  <!-- Challenges Bis Tabs -->
  @if (
    loyaltyChallengeConfig.pages.help.loyaltychallengeBis &&
    bisCampaignActive &&
    loyaltyChallengeConfig.pages.help.loyaltychallengeBis.afterTitle
  ) {
    <div class="container">
      <b2c-bis-campaign-tabs
        [activeTab]="activeTab()"
        (tabChanged)="changeTab($event)"
        [tabs]="loyaltyChallengeConfig.components.bisCampaignTabs || []"
      />
    </div>
  }

  <div class="faq-wrapper">
    <b2c-accordion>
      @for (item of questions(); track $index) {
        <div b2cAccordionItem (isExpanded)="isExpanded($event, $index)">
          <ng-template b2cAccordionHeader>
            <div class="title" [style]="config().accordion.styles.title">
              {{ item.title }}
            </div>
            <!-- Chevron sizes differ per retailer, so NgOptimizedImage's fixed width/height can't be used. -->
            <span class="icon">
              <img
                aria-hidden="true"
                alt=""
                [src]="
                  expandedAccordions.has($index)
                    ? config().accordion.iconLess ||
                      'assets/images/default/expand-less.svg'
                    : config().accordion.iconMore ||
                      'assets/images/default/expand-more.svg'
                "
              />
            </span>
          </ng-template>
          <ng-template b2cAccordionContent>
            @if (expandedAccordions.has($index)) {
              <div
                class="pb-3"
                [innerHTML]="item.content | safe"
                [style]="config().accordion.styles.description"
              ></div>
            }
          </ng-template>
        </div>
      }
    </b2c-accordion>
  </div>
</div>
